<template>
  <div>
    <EditButton
      :disabled="
        !$atividades.permissoes.includes(14) &&
        !$atividades.permissoes.includes(8) &&
        !$atividades.permissoes.includes(2)
      "
      @func="openModal()"
    ></EditButton>
    <SideBar
      title="Editar rota"
      @hide="cancelar"
      @excluir="excluirRota"
      @status="mudarStatusRota"
      :active="modalEditarRota"
      :item="rota"
      :disabled="
        !$atividades.permissoes.includes(15) &&
        !$atividades.permissoes.includes(9) &&
        !$atividades.permissoes.includes(3)
      "
      size="small"
      textSucces="Atualizar"
      @success="submitForm()"
    >
      <div slot="body">
        <vs-row class="mb-4 mt-2" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <vs-input
              class="inputx w-full"
              label-placeholder="ID da rota"
              :value="rota.id != null ? String(rota.id) : ''"
              disabled
            />
          </vs-col>
          <vs-col vs-w="12" class="mt-3">
            <vs-input
              class="inputx w-full"
              label-placeholder="Nome"
              v-model="rota.nome"
              name="nome"
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('nome')">{{
              $validators.empty
            }}</span>
          </vs-col>
          <vs-col vs-w="12" class="mt-3">
            <label class="text-sm">Tipo de veículo</label>
            <el-select
              v-model="rota.id_tipo_veiculo"
              :popper-append-to-body="false"
              clearable
              filterable
              placeholder="Selecione..."
              class="w-full"
              size="small"
            >
              <el-option
                v-for="t in tiposVeiculo"
                :key="t.id"
                :label="t.nome"
                :value="t.id"
              />
            </el-select>
          </vs-col>
          <vs-col vs-w="12" class="mt-3">
            <label class="text-sm">Técnico responsável</label>
            <el-select
              v-model="rota.id_tecnico_responsavel"
              :popper-append-to-body="false"
              clearable
              filterable
              placeholder="Selecione..."
              class="w-full"
              size="small"
            >
              <el-option
                v-for="tec in opcoesTecnicos"
                :key="tec.id"
                :label="tec.nome"
                :value="tec.id"
              />
            </el-select>
          </vs-col>
          <vs-col vs-w="12" class="mt-5">
            <div class="vx-col w-full">
              <vs-checkbox color="success" v-model="rota.levantamento" @input="atualizarLevantamento" class
                >Levantamento</vs-checkbox
              >
            </div>
          </vs-col>
        </vs-row>
      </div>
    </SideBar>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";
import { TIPOS_VEICULO_OPCOES } from "@/constants/tiposVeiculo";

export default {
  name: "modalEditarRota",
  props: { 
    rota: Object,
    tecnicos: { type: Array, default: () => [] }
  },
  data() {
    return {
      tiposVeiculo: TIPOS_VEICULO_OPCOES,
      modalEditarRota: false,
      error: false,
      originalData: {},
      listaTecnicos: [],
    };
  },
  computed: {
    opcoesTecnicos() {
      if (this.listaTecnicos && this.listaTecnicos.length > 0) {
        return this.listaTecnicos;
      }
      return this.tecnicos && this.tecnicos.length > 0 ? this.tecnicos : [];
    }
  },
  watch: {
    'rota.id_tecnico_responsavel': function(newVal) {
      if (newVal) {
        const tec = this.opcoesTecnicos.find(t => t.id === newVal);
        if (tec) {
          this.$set(this.rota, 'tecnico', {
            id: tec.id,
            nome: tec.nome
          });
        }
      } else {
        this.$set(this.rota, 'tecnico', null);
      }
    }
  },
  methods: {
    async buscarTecnicos() {
      this.$vs.loading();
      try {
        const atividades = this.rota.levantamento ? [11] : [10];
        this.listaTecnicos = await this.$http.post('colaboradorAtividade', atividades);
      } catch (e) {
        console.error('Erro ao buscar técnicos:', e);
      } finally {
        this.$vs.loading.close();
      }
    },
    async atualizarLevantamento() {
      this.rota.id_tecnico_responsavel = null;
      await this.buscarTecnicos();
    },
    async openModal() {
      this._beforeEditingCache = Object.assign({}, this.rota);
      this.originalData = this.rota;
      this.modalEditarRota = await true;
      
      // Sempre buscar os técnicos de acordo com a flag de levantamento
      await this.buscarTecnicos();
    },
    async cancelar() {
      Object.assign(this.rota, this._beforeEditingCache);
      this.originalData = this._beforeEditingCache = null;
      this.modalEditarRota = await false;
    },
    async submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.editarRota();
        } else {
          this.error = true;
          this.$vs.notify(this.$notify.Empty);
        }
      });
    },
    async editarRota() {
      this.$vs.loading();
      try {
        const res = await this.$http.put(`rota/${this.rota.id}`, this.rota);
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "atualizar",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Edição da rota N°" + res.id,
        };
        await this.$logger(logData);
        this.$vs.notify(this.$notify.Success);
        this.modalEditarRota = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        this.$vs.loading.close();
        this.$emit("update");
      }
    },
    async excluirRota() {
      this.$vs.loading();
      try {
        await this.$http.delete(`rota/${this.rota.id}`);
        // let logData = {
        //   id_colaborador: localStorage.getItem("id"),
        //   funcao: "excluir",
        //   setor: "comercial",
        //   ip: window.localStorage.getItem("ip"),
        //   texto: "Exclusão da rota N°" + this.rota.id
        // };
        // await this.$logger(logData);
        this.$vs.notify(this.$notify.Success);
        this.modalEditarFornecedor = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        this.$vs.loading.close();
        this.$emit("update");
      }
    },
    async mudarStatusRota() {
      this.$vs.loading();
      try {
        await this.$http.put(`rota/${this.rota.id}`, {
          lixeira: !this.rota.lixeira,
        });
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "atualizar",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Mudança do status da rota N°" + this.rota.id,
        };
        await this.$logger(logData);
        this.$vs.notify(this.$notify.Success);
        this.modalEditarFornecedor = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        this.$vs.loading.close();
        this.$emit("update");
      }
    },
  },
  components: components,
};
</script>
